import { render, staticRenderFns } from "./keyboardPart.vue?vue&type=template&id=029894e6&scoped=true"
import script from "./keyboardPart.vue?vue&type=script&lang=js"
export * from "./keyboardPart.vue?vue&type=script&lang=js"
import style0 from "./keyboardPart.vue?vue&type=style&index=0&id=029894e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029894e6",
  null
  
)

export default component.exports